import DeviceHubIcon from '@mui/icons-material/DeviceHub';
import { Button } from '@mui/material';
import Stack from '@mui/material/Stack';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import variable from '../shared/style/variable';
import vars from '../shared/variable';
import logoMaccaferri from './LogoMaccaferri.svg';
import LogoAppNegative from './LogoAppNegative.png';
import Span from '../shared/component/Span';
import { useNavigate } from 'react-router-dom';
import { route } from '../route/Index';

interface IHeaderProps {}

const ButtonHub = styled(Button)`
    border: 0.1rem solid white;
    border-radius: 0.5rem;
    color: ${variable.white};
`;

const Header = (props: IHeaderProps) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <Stack variant='header' justifyContent='space-between' alignItems='center'>
            <Stack color='white' padding={'0 1rem'} height='100%' width='100%' direction='row' justifyContent='space-between' alignItems='center'>
                <Stack direction='row' alignItems='center' spacing={5}>
                    <Stack style={{ cursor: 'pointer' }}>
                        <img width={200} src={LogoAppNegative} alt='logo-app-maccaferri' onClick={() => navigate(route.home)} />
                    </Stack>
                    <ButtonHub startIcon={<DeviceHubIcon />} onClick={() => (window.location.href = vars.URL_EDESIGN_PORTAL)}>
                        <Span text={t('backToHub')} />
                    </ButtonHub>
                </Stack>
                <Stack sx={{ display: { xs: 'none', sm: 'block' } }} style={{ border: `0.1rem solid ${variable.white}` }}>
                    <img width={150} src={logoMaccaferri} alt='logo-maccaferri' />
                </Stack>
            </Stack>
            <Stack variant='line' />
        </Stack>
    );
};

export default Header;
